import React, { useEffect } from "react";

import { topicDictionary } from "../Util/tileDictionary";

const Topic = ({
  hasSelection,
  isSelected,
  onTopicChange,
  onSubTopicChange,
  topicId,
  subTopicId,
  topic,
}) => {
  useEffect(() => {}, [topicId, isSelected]);

  function handleSubTopicFilterChange(e) {
    const value = e.target.value;
    value === "ALL" ? onSubTopicChange(null) : onSubTopicChange(value);
  }

  function handleTopicChange() {
    onTopicChange(topicId);
  }

  const icon = topicDictionary[topicId] ? topicDictionary[topicId].icon : "";
  return (
    <div
      className={
        hasSelection && !isSelected
          ? "topic-item-container yrbs-cat__color--NotSelected"
          : "topic-item-container yrbs-cat__color--" + topicId
      }
      style={{
        backgroundColor: hasSelection && !isSelected ? "" : topicDictionary[topicId].color,
      }}
    >
      <div
        tabIndex="0"
        className="nav-link-container row m-1"
        onClick={handleTopicChange}
        onKeyDown={(e) => {
          if (e.code === "Enter") handleTopicChange();
        }}
        role="button"
      >
        <div className="col-2 p-0 ">
          <span className={"topic-icon " + icon}></span>
        </div>
        <div className="col-10 ">
          <span className="topic"> {topic.TopicDescription.toLowerCase()}</span>
        </div>
      </div>
      {isSelected && (
        <div className="sub-topic-selector-container">
          { /* <div style={{ fontStyle: "italic", fontSize: "small" }}>Select a Subtopic</div> */ }
          <div className="" role="radiogroup" aria-label="Select a Subtopic">
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name={`subtopic-${topicId}`}
                id={`subtopic-${topicId}-ALL`}
                value="ALL"
                checked={!subTopicId}
                onChange={handleSubTopicFilterChange}
              />
              <label className="form-check-label" htmlFor={`subtopic-${topicId}-ALL`}>
                View All
              </label>
            </div>
            {topic &&
              topic.SubTopics &&
              topic.SubTopics.map((option) => (
                <div className="form-check" key={option.SubTopicId}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`subtopic-${topicId}`}
                    id={`subtopic-${topicId}-${option.SubTopicId}`}
                    value={option.SubTopicId}
                    checked={String(subTopicId) === String(option.SubTopicId)}
                    onChange={handleSubTopicFilterChange}
                  />
                  <label className="form-check-label" htmlFor={`subtopic-${topicId}-${option.SubTopicId}`}>
                    {option.SubTopicDescription}
                  </label>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Topic;
